import client from 'api/client';

export const fetchVersions = (id, locale, vid) =>
  client().get(`/collections/v2/${id}/versions${vid ? `?vid=${vid}` : ''}`, {locale});
